import { withStyles } from '@material-ui/core/styles';
import 'react-date-range/dist/styles.css';
import CalendarRange from './CalendarRange';
import styles from './CalendarRange.styles';
import './theme.css';

export default withStyles(styles)(CalendarRange);
